import React from 'react';
import classNames from 'classnames';
import { money } from 'src/utils/format';

import Link from 'src/components/Link/Link';
import Icon from 'src/components/Icon/Icon';
import { observer } from 'src/utils/mobx-react';
import { DateTime } from 'src_common/utils/time/time';
import { BetReferralNotificationType } from 'src_server/types/notificationData';

type PropsType = {
    currentStaffAccountId: number | null;
    betReferralNotification: BetReferralNotificationType;
    onAssignTrader: (userId: number, assignee: BetReferralNotificationType['details']['assignee']) => void;
};

export const BetReferralNotification = observer('BetReferralNotification', (props: PropsType) => {
    const { betReferralNotification, currentStaffAccountId } = props;
    const age = DateTime.from(betReferralNotification.createdAt)?.fromNow();
    const { details, status } = betReferralNotification;

    const classNamesList = classNames([
        'bet-referral-notification',
        'notification',
        {
            pending: status === 'pending',
            ongoing: status === 'ongoing' && details.assignee !== null,
        },
    ]);

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const sports = details.sports ?? [];
    const sportsLabel = sports.length < 2 ? sports[0]?.name : 'Multiple sports';

    let assigneeInfo;
    if (details.assignee !== null) {
        assigneeInfo = (
            <div className='bet-referral-notification__assignee'>
                <p>
                    Bet referral is assigned to
                    <strong>{details.assignee.id === currentStaffAccountId ? 'you' : details.assignee.name}</strong>
                </p>
            </div>
        );
    }

    return (
        <div className={classNamesList}>
            <div className='type'>Bet Referral</div>
            <div>
                {betReferralNotification.accountName} &nbsp; ({details.stakeFactor})
                {details.freebet === true ? (
                    <span className='bet-referral-notification__freebet'>
                        <Icon name='gift' /> Free Bet
                    </span>
                ) : (
                    void 0
                )}
            </div>
            <div>
                {money(details.totalStake, details.currency)} &nbsp; {details.currency}
            </div>
            <div>{sportsLabel}</div>

            {assigneeInfo}
            <div>
                <div className='time'>{age}</div>
                <div className='buttons'>
                    <Link
                        route={`customers:${betReferralNotification.accountId}`}
                        parameters={{ betslip: 'betslip' }}
                        onClick={() => props.onAssignTrader(betReferralNotification.accountId, details.assignee)}
                        className='btn'
                    >
                        View Bet
                    </Link>
                </div>
            </div>
        </div>
    );
});
